import React, { useCallback } from 'react';
import { getIconBaseUrl } from '../../../utils/assets';
import { Label } from '../../Label';
import { NestedMultiSelect } from '../NestedMultiSelect';
export const ParkMultiSelect = ({ regionsWithParks, value, onValueChange, analytics, showTown = false, showSelectAll = false, showNoDogsAllowed = true, showSearch = false, }) => {
    const options = regionsWithParks.map((region) => ({
        title: region.name,
        value: region.code,
        subOptions: region.parks.map(({ name: title, town: subTitle, code: value, label, features }) => ({
            title,
            subTitle: showTown ? subTitle : undefined,
            value,
            subLabel: (<>
            {(label === null || label === void 0 ? void 0 : label.text) ? (<Label text={label.text} variant={label.variant} palette={label.palette} nowrap/>) : null}
            {showNoDogsAllowed && !(features === null || features === void 0 ? void 0 : features.allowDogs) ? (<img alt='No dogs allowed' src={getIconBaseUrl('no-dogs-grey.svg')}/>) : null}
          </>),
        })),
    }));
    const handleAnalytics = useCallback((checked, filterValue) => {
        analytics === null || analytics === void 0 ? void 0 : analytics({
            event: 'visitor interaction',
            interactionName: 'filter click',
            productType: 'self catering',
            filterAction: checked ? 'apply' : 'remove',
            filterCategory: 'location',
            filterValue,
        });
    }, [analytics]);
    return (<>
      <NestedMultiSelect options={options} defaultValues={value} onChange={onValueChange} searchInputPlaceholder='Type to search region/park' searchable={showSearch} handleAnalytics={handleAnalytics} analytics={analytics} selectAllLabel={showSelectAll ? 'All parks and regions' : undefined}/>
    </>);
};
